// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redemptions-report-page {
  padding: 0 var(--spacing-regular);
}
.redemptions-report-page .page-title {
  color: var(--color-highlight);
}
.redemptions-report-page .id-input::-webkit-outer-spin-button,
.redemptions-report-page .id-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/RedemptionsReportPage/RedemptionsReport.less"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ;AAFA;EAIQ,6BAAA;AACR;AALA;;EASQ,wBAAA;EACA,SAAA;AAAR","sourcesContent":[".redemptions-report-page {\n    padding: 0 var(--spacing-regular);\n\n    .page-title {\n        color: var(--color-highlight)\n    }\n\n    .id-input::-webkit-outer-spin-button,\n    .id-input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
